// The legacy admin controllers sit behind Rails CSRF protection, unlike the plato_api
// endpoints — SPA calls to them need the token from the page's meta tag.
const csrfToken = () => (
  document.querySelector<HTMLMetaElement>('meta[name=csrf-token]')?.content ?? ''
);

export default csrfToken;
